import AmioHttpService from './amio-http.service'
import { REPORT_STATUSES } from '@/store/constants'

class TestReportService extends AmioHttpService {

  async fetchReport(nlpModelId, status) {
    const params = {}
    if (status) {
      params.status = status
    }

    try {
      const { data } = await this.requestGet(`/nlp-models/${nlpModelId}/verifications/last`, { params })
      return this._adaptData(data)
    } catch (err) {
      const error = this.handleError(err)
      if (error.response.status === 404) {
        return {
          status: REPORT_STATUSES.NEVER_RUN
        }
      } else {
        throw error
      }
    }
  }

  async startReport(nlpModelId, { skipPublish, skipTests }) {
    try {
      const { data } = await this.requestPost(`/nlp-models/${nlpModelId}/verifications`, {
        skip_publish: skipPublish,
        skip_tests: skipTests
      })
      return data
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async subscribeToReportUpdate(nlpModelId, id) {
    const subscribeUrl = `/nlp-models/${nlpModelId}/verifications/${id}/updates`
    try {
      const { data } = await this.requestGet(subscribeUrl)
      return this._adaptData(data)
    } catch (err) {
      if (err.response.status === 404) {
        throw this.handleError(err)
      }
      await new Promise(resolve => setTimeout(resolve, 5000))
      return await this.subscribeToReportUpdate(subscribeUrl)
    }
  }

  _adaptData(data) {
    const report = {
      status: data.status, lastRunDatetime: data.timestamp_end, id: data.id
    }
    if (data.report) {
      report.failedIntents = Object.values(data.report.failed_intents)
    }
    return report
  }
}

export default new TestReportService()
